<template>
    <div>
        <el-row>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top:24px">
                <el-breadcrumb-item :to="{ path: '/formalUserManage' }" style="font-size:24px">人员管理</el-breadcrumb-item>
                <el-breadcrumb-item style="font-size:24px">人员权限匹配</el-breadcrumb-item>
            </el-breadcrumb>
        </el-row>
        <el-row>
            <el-col>
                <el-button @click="addNewActor" style="margin-top:20px">新增</el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-table :data="tableData" stripe border style="margin-top:20px">
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
                    <el-table-column prop="USER_TYPE" label="角色"></el-table-column>
                    <el-table-column>
                        <template slot-scope="scope">
                            <el-button type="text" @click="deleteActor(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-dialog title="新建关联" center :visible.sync="addFormVisible" width="700px" :close-on-click-modal="false">
                    <el-form :model="addForm" ref="addForm" style="margin-top: 0">
                        <el-form-item label="项目点：" :label-width="formLableWidth">
                            <el-select v-model="addForm.PROJECT" filterable placeholder="请选择" clearable style="width:100%" @change="querySearch">
                                <el-option v-for="item in points" :key="item.PROJECT_ID" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
                                <!-- <span style="float: left">{{ item.NAME }}</span> -->
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="角色：" :label-width="formLableWidth">
                            <el-checkbox-group v-model="addForm.checkList">
                                <el-checkbox  v-for='(item,index) in checkLists' :label='item.value' :key="index">{{item.name}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="close('addForm')">取 消</el-button>
                        <el-button @click="submitAdd('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import http from '@/api/base/http';

export default {
  data() {
    return {
      addForm: {
        checkList: [],
      },
      points: [],
      addFormVisible: false,
      formLableWidth: '100px',
      tableData: [],
      searchForm: {},
      checkLists: [
        {
          name: '高级客服',
          value: 2,
        },
        {
          name: '合规总监',
          value: 4,
        },
        {
          name: '运营总监',
          value: 3,
        },
        {
          name: '财务',
          value: 5,
        },
      ],
    };
  },
  methods: {
    addNewActor() {
      this.addFormVisible = true;
    },
    // submitAdd () {

    // },
    close() {
      this.addFormVisible = false;
    },
    queryProject() {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 8,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        TC_ID: sessionStorage.getItem('companyId'),
      };
      http.post(params).then((result) => {
        this.points = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryTable() {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 4,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        TC_USER_ID: sessionStorage.getItem('USER_ID'),
      };
      http.post(params).then((result) => {
        this.tableData = result;
        console.log(this.tableData);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    deleteActor(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10010',
            OTYPE: 5,
            USER_ID: parseInt(sessionStorage.getItem('userId')),
            SESSION: sessionStorage.getItem('session'),
            TC_USER_ID: sessionStorage.getItem('USER_ID'),
            PROJECT_ID: row.PROJECT_ID,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    querySearch() {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 6,
        USER_ID: parseInt(sessionStorage.getItem('userId')),
        SESSION: sessionStorage.getItem('session'),
        TC_USER_ID: sessionStorage.getItem('USER_ID'),
        PROJECT_ID: this.addForm.PROJECT,
      };
      http.post(params).then((result) => {
        this.addForm.checkList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            SERVICE_ID: '10010',
            OTYPE: 7,
            USER_ID: parseInt(sessionStorage.getItem('userId')),
            SESSION: sessionStorage.getItem('session'),
            TC_USER_ID: sessionStorage.getItem('USER_ID'),
            PROJECT_ID: this.addForm.PROJECT,
            TYPE_ARRAY: this.addForm.checkList,
          };
          http.post(params).then((result) => {
            this.$message.show({ text: '添加成功', type: 'success' });
            this.addFormVisible = false;
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
  },
  created() {
    this.queryProject();
    this.queryTable();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/peopleActor.vue